export interface MembershipCapabilitiesResponse {
    userCapabilities: MembershipUnitCapability[]
}

export interface MembershipUnitCapability {
    id: number,
    level: number,
    capabilities: MembershipCapabilityLevel
}

export enum MembershipCapabilityLevel {
    full = 'full',
    partial= 'partial'
}

export enum Domains {
    Membership = 'membership',
    ProGuest = 'proGuest',
    Directory = 'directory',
    Machines = 'machines'
}

export enum ProGuestCapabilityType {
    Provider = 'provider',
    Admin = 'admin'
}

export type ProGuestCapability  = ProGuestCapabilityType[];
export type MachineCapability = boolean;
export type MembershipCapability = {[id: number]: MembershipUnitCapability};

export type UserCapability = {
    [Domains.Membership]: MembershipCapability,
    [Domains.ProGuest]: ProGuestCapability,
    [Domains.Machines]: MachineCapability
}